import { useState } from 'react'
import SectionTitle from '../../common/SectionTitle'
import Input from '../../common/Input'
import Button from '../../common/Button'
import testEmail from '../../../utils/testEmail'

import './_SubscribeSection.scss'

import phoneImg from '../../../assets/images/form-section/phone-img.png'

const SubscribeSection = () => {
  const [ email, setEmail ] = useState('')
  const [ error, setError ] = useState('')
  const [ errorMsg, setErrorMsg ] = useState('')

  const onSubmit = e => {
    e.preventDefault()

    if (!email) {
      return
    }

    if (!testEmail(email)) {
      setError(true)
      setErrorMsg('Your email is not found!')
    } else {
      setError(false)
      setErrorMsg('')
    }
  }

  return (
    <div className='SubscribeSection'>
      <div className='overlay section-padding'>
        <div className='container'>
          <div className='phone-img-box'>
            <img src={phoneImg} alt='' className='phone-img' />
          </div>
          <div className='form-box'>
            <SectionTitle
              title='Subscribe our newsletter'
              text='Subscribe to our newsletter to stay in touch with all the latest news'
            />
            <form className='subscribe-form' onSubmit={onSubmit}>
              <Input
                value={email}
                setValue={setEmail}
                placeholder='Enter your email'
                error={error || error}
                errorMessage={(error && errorMsg) || errorMsg}
              />
              <Button type='submit'>Subscribe</Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}


export default SubscribeSection
